import { useCallback, useState } from "react"

export function usePartialState<T> (defaultValue?: T | (() => T)) {
  const [state, setState] = useState<T>(defaultValue)

  const setPartialState: React.Dispatch<React.SetStateAction<Partial<T>>> = useCallback(arg => {
    setState(prevState => {
      const newValue = typeof arg === "function" ? (arg as any)(prevState) : arg
      return { ...prevState, ...newValue }
    })
  }, [])

  return [state, setPartialState, setState] as const
}
